import {
  BoundingBox,
  CardinalBounds,
  InterCardinalBounds
} from "@irati/geolocation/src/types"

export const getCardinalBoundsFromInterCardinalBounds = ({ne, sw}: InterCardinalBounds): CardinalBounds => {
  return getCardinalBoundsFromBoundingBox([ne.lat, ne.lng, sw.lat, sw.lng])
}

export const getCardinalBoundsFromBoundingBox = (boundingBox: BoundingBox): CardinalBounds => {
  const n = {
    lat: boundingBox[0],
    lng: boundingBox[3] + ((boundingBox[1] - boundingBox[3]) / 2)
  }
  const e = {
    lat: boundingBox[2] + ((boundingBox[0] - boundingBox[2]) / 2),
    lng: boundingBox[1]
  }
  const s = {
    lat: boundingBox[2],
    lng: boundingBox[3] + ((boundingBox[1] - boundingBox[3]) / 2)
  }
  const w = {
    lat: boundingBox[2] + ((boundingBox[0] - boundingBox[2]) / 2),
    lng: boundingBox[3]
  }
  return {n, e, s, w}
}
